import { render, staticRenderFns } from "./cart-totals.vue?vue&type=template&id=15ef0e4c&scoped=true&"
import script from "./cart-totals.vue?vue&type=script&lang=js&"
export * from "./cart-totals.vue?vue&type=script&lang=js&"
import style0 from "./cart-totals.vue?vue&type=style&index=0&id=15ef0e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ef0e4c",
  null
  
)

export default component.exports